import store, { history } from '../store';

export const CLOSE_MODAL = 'CLOSE_MODAL';

const closeModal = modalType => (
  (dispatch) => {
    if (window !== window.parent && window.parent.hideInlineLead !== undefined) {
      window.parent.hideInlineLead();
      return;
    }

    const state = store.getState();

    if (state.modal.path) {
      history.push(state.modal.path);

      dispatch({
        type: CLOSE_MODAL,
      });

      return;
    }

    let path = '';

    if (modalType !== undefined) {
      if (modalType === 'opportunity-lead-view') {
        path = 'available';
      }

      if (modalType === 'accepted-lead-view') {
        path = 'purchased';
      }
    } else if (store.getState().leads.params.type) {
      path = store.getState().leads.params.type;

      if (path === 'opportunity') {
        path = 'close-match';
      }

      if (path === 'accepted') {
          path = 'matched';
      }

      if (path === 'accepted') {
        path = 'received';
      }
    }

    history.push(`/leads/${path}`);

    dispatch({
      type: CLOSE_MODAL,
    });
  }
);

export default closeModal;
